import {KalmanFilter} from "kalman-filter";

const ConstantSpeed = function() {
    return new KalmanFilter({
        observation: {
            sensorDimension: 2,
            name: "sensor"
        },
        dynamic: {
            name: "constant-speed",
            covariance: [1, 1, 1, 1]
        }
    });
};

export default ConstantSpeed;
